import { translate } from "@locales";
import { client } from "@models/api/dato-cms-client";
import { COUNT_DOWN_DATE } from "@models/api/count-down-data";
import { useEffect, useState } from "react";
import classNames from "classnames";
import { SolidButton } from "@components/atoms/base-button";
import { useAtom } from "jotai";
import { showCountdownAtom } from "@models/state/count-down";
import { Link } from "@shopify/hydrogen";

function useCountDown() {
  const [data, setData] = useState<any>();
  const targetDateTime = new Date(data?.countDown?.datetime).getTime();
  const [showCountdown, setShowCountdown] = useAtom(showCountdownAtom);
  const [timeRemaining, setTimeRemaining] = useState({
    days: "00",
    hours: "00",
    minutes: "00",
    seconds: "00",
  });

  useEffect(() => {
    client.query({ query: COUNT_DOWN_DATE, fetchPolicy: "no-cache" }).then((res) => {
      setData(res.data);
      setShowCountdown(res?.data?.countDown?.active);
    });
  }, []);

  const formatToTwoDigits = (value: number): string => {
    return value < 10 ? `0${value}` : `${value}`;
  };

  useEffect(() => {
    let interval: NodeJS.Timer;
    if (showCountdown) {
      const calculateTimeRemaining = () => {
        const now = new Date().getTime();
        const timeDiff = targetDateTime - now;
        if (timeDiff <= 0) {
          clearInterval(interval);
        } else {
          const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
          const hours = Math.floor(
            (timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
          );
          const minutes = Math.floor(
            (timeDiff % (1000 * 60 * 60)) / (1000 * 60)
          );
          const seconds = Math.floor((timeDiff % (1000 * 60)) / 1000);

          setTimeRemaining({
            days: formatToTwoDigits(days),
            hours: formatToTwoDigits(hours),
            minutes: formatToTwoDigits(minutes),
            seconds: formatToTwoDigits(seconds),
          });
        }
      };
      interval = setInterval(calculateTimeRemaining, 1000);

      return () => {
        clearInterval(interval);
      };
    }
  }, [data, targetDateTime]);

  return {
    models: {
      timeRemaining,
      countDown: data?.countDown,
      showCountdown,
    },
  };
}

export function CountDown() {
  const { models } = useCountDown();

  return (
    <>
      <div
        style={{ backgroundColor: models.countDown?.bgcolor }}
        className={classNames(
          "w-full h-[80px] absolute  text-white flex items-center flex-row  top-0 z-40 justify-between",

          {
            hidden: !models.showCountdown,
          }
        )}
      >
        <div className="ml-4 lg:ml-14 flex flex-row items-center">
          <span className="font-chivo-bold text-xs lg:text-[22px] mr-2 lg:mr-0 leading-6  ">
            {models.countDown?.title}
          </span>
        </div>
        {models?.countDown?.datetime && (
          <div className="flex flex-row items-center text-[18px]">
            {Object.keys(models.timeRemaining).map((Key, index) => {
              return (
                <div
                  key={`timer-${index}`}
                  className="flex lg:flex-row flex-col items-center mr-2"
                >
                  <span
                    className={classNames(
                      "h-[32px] w-[38px] lg:h-[40px] lg:w-[49px] text-[25px] lg:text-[32px]",
                      "p-2 px-3 rounded flex  items-center justify-center bg-white text-[#672080] mr-1"
                    )}
                  >
                    {models.timeRemaining[Key as keyof typeof models.timeRemaining] ?? 0}
                  </span>
                  <span className="text-[8px] lg:text-[18px]">
                    {translate(`count-down-info.${Key}`)}
                  </span>
                </div>
              );
            })}
          </div>
        )}
        {models.countDown?.buttonTitle && (
          <Link
            to={models.countDown?.productLink ?? ""}
            className="xl:block hidden"
          >
            <SolidButton
              style={{ backgroundColor: models.countDown?.buttonColor }}
              className={classNames(
                "mr-4 lg:mr-14  w-[200px] h-[50px]  shadow-lg"
              )}
              title={models.countDown?.buttonTitle}
            >
              {models.countDown?.buttonTitle}
            </SolidButton>
          </Link>
        )}
      </div>
    </>
  );
}